import { schema } from 'normalizr';

import type { ViewerBody, ViewerPart, ViewerPartFile } from './types';

const partFileSchema = new schema.Entity<ViewerPartFile>(
  'partFiles',
  {},
  {
    idAttribute: 'uuid',
  },
);

const viewerPartSchema = new schema.Entity<ViewerPart>('viewerParts', {
  partFile: partFileSchema,
});

const viewerBodySchema = new schema.Entity<ViewerBody>(
  'viewerBodies',
  {},
  {
    idAttribute: 'viewerId',
  },
);

viewerBodySchema.define({
  children: [viewerBodySchema],
  viewerPart: viewerPartSchema,
});

export { partFileSchema, viewerBodySchema, viewerPartSchema };
